let config = {}
if (process.env.NODE_ENV === 'development') {
  config = {
    email: 'info@b1g1.com',
    server: 'http://127.0.0.1:8000',
    host: 'http://localhost:8080',
    client_id: 1,
    client_secret: 'Fo72n242PouyI7J3HfnR6uMaHcHG124zgvuUQFhX',
    grant_type: 'password',
    membership: 'U2FsdGVkX1+pr1WMufBh8YwfK96DQ3Bt4EDbgyEjLEJnVLJYy4t+3cK5q4kg3cwtkdCYtBMfdorFi3X2Qrhb9g==',
    giving: 'U2FsdGVkX1/yZ7omA6ijGhA0unvLcDosIZ1XmStSncCi+Qq+aPN459z1Na8vpzzg/Ite4x5PWInw/o/6Jm+3FA==',
    payment_server: 'https://payment.b1g1.org',
    hotjar_id: '2673959',
    wcuser_id: 13192,
    environment: 'development',
    purchase_account_amt: 30,
    restricted_countries: ['United States'],
    charity_disclosure_countries: ['United States'],
    smallest_package_name: 'Tiny',
    restricted_states: []
  }
} else if (process.env.NODE_ENV === 'production') {
  config = {
    email: 'info@b1g1.com',
    // server: 'https://stage-api.b1g1.com',
    server: 'https://design-api.b1g1.com',
    host: 'https://stage.b1g1.com',
    client_id: 6,
    client_secret: 'yfKa4pJgdihXhChlSYzKnGG1J7MVy2wqH8fhrX6w',
    grant_type: 'password',
    membership: 'U2FsdGVkX1+pr1WMufBh8YwfK96DQ3Bt4EDbgyEjLEJnVLJYy4t+3cK5q4kg3cwtkdCYtBMfdorFi3X2Qrhb9g==',
    giving: 'U2FsdGVkX1/yZ7omA6ijGhA0unvLcDosIZ1XmStSncCi+Qq+aPN459z1Na8vpzzg/Ite4x5PWInw/o/6Jm+3FA==',
    payment_server: 'https://payment.b1g1.org',
    hotjar_id: '2673959',
    wcuser_id: 13192,
    stripeKey1: 'pk_test_xb8XzR8Fd4nS72UhefumZahW',
    stripeKey2: 'pk_test_xb8XzR8Fd4nS72UhefumZahW',
    environment: 'production',
    purchase_account_amt: 30,
    restricted_countries: ['United States'],
    charity_disclosure_countries: ['United States'],
    smallest_package_name: 'Tiny',
    restricted_states: [],
    milestone_maximum_contribution_limit: 6
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/app.js